/**
 * Converia.Core.module
 *
 * Converia.SiteStructure.RowEditAp
 */

Converia.Core.module('Converia.SiteStructure.RowEditApp', function () {
    /**
     * App
     * 
     * @param domElement
     * @param rowContent
     * @param configuration
     * @constructor
     */
    var App = function (domElement, rowContent, configuration) {
        var app = this;

        this.articleUrl = configuration.article_url;
        this.articleEditUrl = configuration.article_edit_url;
        this.rowContent = new Converia.SiteStructure.RowContent(
            configuration.split_options
        );

        if (rowContent) {
            this.rowContent.loadFromJson(rowContent);
        } else {
            this.rowContent.initDefault();
        }

        this.form = new Converia.SiteStructure.Form(domElement);
        this.view = new Converia.SiteStructure.View(domElement, configuration.split_options);
        this.currentColumn = null;

        // init all listeners here
        $(this.view.getDomElement()).on(
            'click',
            '[data-row-click]',
            function (event) {
                var element = this;
                app.onClick(event, element);
            }
        );

        $(this.view.getDomElement()).on(
            'change',
            '[data-row-change]',
            function (event) {
                var element = this;
                app.onCange(event, element);
            }
        );

        $(this.view).on(
            'rendered',
            function (event) {
                app.onViewRendered(event);
            }
        );

        $(this.form.getDomElement()).on(
            'submit',
            function (event) {
                var element = this;
                app.onFormSubmit(event, element);
            }
        );
    };

    /**
     * App.prototype.onViewRendered
     * 
     * @param event
     */
    App.prototype.onViewRendered = function (event) {
        var that = this;
        var domWrapper = $(this.view.getDomElement());
        var sortConfig = {
            axis: "y",
            handle: '[data-row-sorter]',
            cancel: '',
            update: function (event, ui) {
                $(this).sortable('disable'); //pause sorting until list is reloaded with new order
                var articleList = ui.item.closest('[data-row-article-list]');
                var columnIndex = articleList.data('row-column-index');
                var column = that.rowContent.getColumns()[columnIndex];
                var newOrder = [];
                articleList.find('[data-row-article-list-entry]').each(
                    function (index, listElement) {
                        newOrder.push(parseInt($(this).data('row-article-index')));
                    }
                );
                column.setNewArticleOrder(newOrder);
                that.render();

            }
        };

        $(domWrapper).find('[data-row-article-list]').sortable(sortConfig);
    };

    /**
     * App.prototype.onClick
     * 
     * @param event
     * @param element
     */
    App.prototype.onClick = function (event, element) {
        var action = $(element).data('row-click');
        var data = $(element).data('row-click-data');

        switch (action) {
            case 'add-article':
                var columnId = parseInt(data);
                this.currentColumn = this.rowContent.getColumns()[columnId];
                var element = this.view.getArticleBrowserSelectElement();
                var url = this.articleUrl.replace('__callback__', element.id);
                BEGUI.Modal.instance.showUrlAsModal(url, '', {});
                return;//do not rerender here
                break;
            case 'remove-article':
                var columnId = $(element).data('row-column-index');
                var articleId = $(element).data('row-article-index');
                var column = this.rowContent.getColumns()[columnId];
                column.removeArticleWithIndex(articleId);
                break;
            case 'edit-article':
                var articleIndex = $(element).data('row-article-index');
                var columnId = $(element).data('row-column-index');
                var column = this.rowContent.getColumns()[columnId];
                var article = column.getArticleWithIndex(articleIndex);
                var url = this.articleEditUrl.replace('__id__', article.getId());
                BEGUI.Modal.instance.showUrlAsModal(url, '', {});
                break;
            default:
                throw new Error('Unknown action: ' + action);
        }

        this.render();
    };

    /**
     * App.prototype.setColumnSplit
     * 
     * @param splitValue
     */
    App.prototype.setColumnSplit = function (splitValue) {
        var currentColumnCount = this.rowContent.getColumns().length;
        var newColumnCount = this.rowContent.getColumnCountForSplitValue(splitValue);
        while (currentColumnCount < newColumnCount) {
            this.rowContent.addColumn();
            currentColumnCount++;
        }

        while (currentColumnCount > newColumnCount) {
            this.rowContent.removeLastColumn();
            currentColumnCount--;
        }

        this.rowContent.setColumnSplit(splitValue);
    };

    /**
     * App.prototype.onCange
     * 
     * @param event
     * @param element
     */
    App.prototype.onCange = function (event, element) {
        var action = $(element).data('row-change');
        switch (action) {
            case 'change-column-split':
                var splitValue = $(element).val();
                var currentColumnCount = this.rowContent.getColumns().length;
                var newColumnCount = this.rowContent.getColumnCountForSplitValue(splitValue);

                if (currentColumnCount > newColumnCount) {
                    var dialog = this.view.showConfirmDialog();
                    var that = this;

                    $(dialog).on('dialog-action', function (event, data) {
                        var actionKey = data.actionKey;

                        if (actionKey === 'abort') {
                            that.render();
                        } else if (actionKey === 'confirm') {
                            dialog.forceClose();
                            that.setColumnSplit(splitValue);
                            that.render();
                        } else {
                            throw new Error("Action not found: " + actionKey);
                        }
                    });

                    return;//do not rerender here
                }

                this.setColumnSplit(splitValue);
                break;
            case 'article-selected':
                var articleId = parseInt($(element).val());
                var articleName = $(this.view.getArticleBrowserSelectElement()).find('option:selected').text()

                if (!this.currentColumn) {
                    throw new Error('No column found to add article.');
                }

                this.currentColumn.addArticle(
                    new Converia.SiteStructure.Article(
                        {
                            id: articleId,
                            shownName: articleName
                        }
                    )
                );

                break;
            default:
                throw new Error('Unknown action: ' + action);
        }

        this.render();
    };

    /**
     * App.prototype.onFormSubmit
     * 
     * @param event
     * @param element
     */
    App.prototype.onFormSubmit = function (event, element) {
        var jsonData = this.rowContent.toJson();

        $(this.form.getInputElement()).val(JSON.stringify(jsonData));
    };

    /**
     * App.prototype.render
     */
    App.prototype.render = function () {
        this.view.clear();
        this.view.render(this.rowContent);
    };

    return App;
});
